import { MenuItem } from '../types/menu';

export const menuItems: MenuItem[] = [
  {
    id: '1',
    name: 'Kal Dosa',
    description: '3 pcs with Sambar & Chutney',
    price: 5.99,
    image: 'https://images.unsplash.com/photo-1630383249896-424e482df921?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '2',
    name: 'Medhu Vadai',
    description: '2pcs Served with Sambar & Chutney',
    price: 2.50,
    image: 'https://images.unsplash.com/photo-1589647363585-f4a7d3877b10?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '3',
    name: 'Veg Pakora',
    description: 'with gram flour fresh Mix Vegetables',
    price: 3.00,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '4',
    name: 'Plain Rice & Sambar Veg Side',
    description: 'Served with fresh vegetables',
    price: 4.99,
    image: 'https://images.unsplash.com/photo-1516714435131-44d6b64dc6a2?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '5',
    name: 'Plain Rice Sambar & Vadai Veg side',
    description: 'Complete meal with vadai',
    price: 5.60,
    image: 'https://images.unsplash.com/photo-1505253716362-afaea1d3d1af?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '6',
    name: 'Falafel Wraps',
    description: 'Fresh made falafel with vegetables',
    price: 4.99,
    image: 'https://images.unsplash.com/photo-1592415499556-74fcb9f18667?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '7',
    name: 'Veg Fried Rice',
    description: 'Indo-Chinese style with vegetables',
    price: 4.50,
    image: 'https://images.unsplash.com/photo-1645177628172-a94c1f96e6db?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '8',
    name: 'Veg Kothu',
    description: 'No Egg, pure vegetarian',
    price: 5.50,
    image: 'https://rlghpeuxrtidtcolzmkp.supabase.co/storage/v1/object/public/menu_images/menu_images/vegkothu.png',
    category: 'veg'
  },
  {
    id: '9',
    name: 'Veg Samosa',
    description: '2pcs with Can of Drink',
    price: 2.60,
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '10',
    name: 'Chapatti',
    description: '2pcs with Dal Curry',
    price: 4.00,
    image: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '11',
    name: 'Mint Tea',
    description: 'Fresh brewed mint tea',
    price: 1.20,
    image: 'https://images.unsplash.com/photo-1597481499750-3e6b22637e12?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '12',
    name: 'Tea with Milk',
    description: 'Classic Indian milk tea',
    price: 1.60,
    image: 'https://images.unsplash.com/photo-1561336313-0bd5e0b27ec8?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '13',
    name: 'Sago Pudding',
    description: 'Traditional sweet dessert',
    price: 2.90,
    image: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '14',
    name: 'Carrot Halwa',
    description: 'Traditional Indian dessert',
    price: 2.00,
    image: 'https://images.unsplash.com/photo-1589216532372-1c2a367900d9?auto=format&fit=crop&w=600&q=80',
    category: 'veg'
  },
  {
    id: '15',
    name: 'Mutton Roll',
    description: '2pcs, freshly prepared',
    price: 3.00,
    image: 'https://images.unsplash.com/photo-1633237308525-cd587cf71926?auto=format&fit=crop&w=600&q=80',
    category: 'non-veg'
  },
  {
    id: '16',
    name: 'Chicken Roll',
    description: '2pcs, freshly prepared',
    price: 3.00,
    image: 'https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?auto=format&fit=crop&w=600&q=80',
    category: 'non-veg'
  },
  {
    id: '17',
    name: 'Chicken Wrap',
    description: 'Fresh vegetables and grilled chicken',
    price: 4.99,
    image: 'https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?auto=format&fit=crop&w=600&q=80',
    category: 'non-veg'
  },
  {
    id: '18',
    name: 'Chicken Curry',
    description: 'Plain Rice & Veg Side',
    price: 5.99,
    image: 'https://images.unsplash.com/photo-1589647363585-f4a7d3877b10?auto=format&fit=crop&w=600&q=80',
    category: 'non-veg'
  }
];